export function resolveFirstUnreadMessageId(meta, enabled = false) {
  if (!enabled) return null;

  const messageId = Number(meta?.first_unread_message_id || 0);
  return Number.isInteger(messageId) && messageId > 0 ? messageId : null;
}
